import { render, staticRenderFns } from "./AttendeesList.vue?vue&type=template&id=0f242410&scoped=true"
import script from "./AttendeesList.vue?vue&type=script&lang=js"
export * from "./AttendeesList.vue?vue&type=script&lang=js"
import style0 from "./AttendeesList.vue?vue&type=style&index=0&id=0f242410&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f242410",
  null
  
)

export default component.exports